import type { TilesetVersion, TilesetWithVersions } from "../types/tileset";

export function getCurrentVersion({ versions, tileset }: TilesetWithVersions): TilesetVersion | null {
  const {
    currentVersionId,
  } = tileset;

  const firstVersion = versions.find(v => v.status !== "failed");

  if (firstVersion && !currentVersionId) {
    return firstVersion;
  }
  return versions.find(v => v.id === currentVersionId) as TilesetVersion | null;
};
